/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Feature1Inputs */

const en_st_mock_feature1 = /** @type {(inputs: St_Mock_Feature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in & sessions`)
};

const id_st_mock_feature1 = /** @type {(inputs: St_Mock_Feature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk & sesi`)
};

/**
* | output |
* | --- |
* | "Sign-in & sessions" |
*
* @param {St_Mock_Feature1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_feature1 = /** @type {((inputs?: St_Mock_Feature1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Feature1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_feature1(inputs)
	return en_st_mock_feature1(inputs)
});